import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { contains, path } from 'ramda';
import { withRouter } from 'react-router';

import { worksheet } from 'constants/routes';
import { openModalWorksheetUnsupported } from 'actions/modalActions';
import { WORKSHEET_DISABLE_STATUSES } from 'constants/worksheet';

@withRouter
@connect(null, { openModalWorksheetUnsupported })
export default class WorksheetLink extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        item: PropTypes.object.isRequired,
        openModalWorksheetUnsupported: PropTypes.func
    };

    openWorksheet = () => {
        const { history, item: { id, groupNameStatus }, openModalWorksheetUnsupported } = this.props;

        if (contains(groupNameStatus, WORKSHEET_DISABLE_STATUSES)) {
            openModalWorksheetUnsupported();
        } else {
            history.push(worksheet.stringify({ id }));
        }
    }

    render () {
        return (
            <a onClick={this.openWorksheet}>
                <span>{path(['item', 'posname', '0', 'text'], this.props)}</span>
            </a>
        );
    }
}
